module.exports = __webpack_public_path__ + "build/img/tan.cc6ffb3c.png";